<script lang="ts" setup>
import { computed } from 'vue'
import IconDocument from '@lahaus-roomie/roomie/src/assets/icons/document.svg'
import type { Props } from './types'

import AppImagesGrid from '@/components/App/ImagesGrid/index.vue'

const props = defineProps<Props>()

const images = computed(() => props.attachments.filter(attachment => attachment.media_type === 'image').map(attachment => attachment.media_url))
const documents = computed(() => props.attachments.filter(attachment => attachment.media_type === 'document'))
</script>

<script lang="ts">
export default {
  name: 'AppChatMigratedAttachments'
}
</script>

<template>
  <div v-if="documents.length">
    <a
      v-for="(document, index) in documents"
      :key="`document-${index}`"
      class="w-full flex items-center gap-4"
      :href="document.media_url"
      :data-lh-id="`${screen}-app-chat-button-open-document-attachment`"
      target="_blank">
      <IconDocument class="fill-primary-600 w-24 h-24 pointer-events-none" />

      <p class="text-primary-600 underline pointer-events-none ">
        {{ document.title || 'Documento' }}
      </p>
    </a>
  </div>

  <AppImagesGrid
    v-if="images.length"
    :id="`${screen}-app-chat`"
    :images
    :max-images-in-grid="4"
    :image-multiplier="7" />
</template>
